import { title } from "./title";

export function to_var(v, _class = false) {
  if (!v || !(typeof v === "string")) {
    throw "No Var";
  }

  v = v.replace(new RegExp(/[ ]+/g), "_");

  let variable = v.split("_");

  if (variable.length > 1) {
    variable =
      (!_class ? variable[0].toLowerCase() : title(variable[0])) +
      variable
        .slice(1)
        .map(x => title(x))
        .join("");
  } else {
    variable = !_class ? variable[0].toLowerCase() : title(variable[0]);
  }

  return variable;
}

export const camelToSnakeCase = str =>
  str[0].toLowerCase() +
  str
    .slice(1, str.length)
    .replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
